<template>
  <div>
    <a-card v-if="CustomerExpenselist" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <!--        筛选的条件-->
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in orderstatus" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientProvince" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                        >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientCity" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientArea" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddr" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" style="margin-left: 26px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseName"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="市场负责人" style="margin-left: 15px">
                <a-select v-model="queryParam.marketPrincipal" :allowClear="true">
                  <a-select-option v-for="type in marketPrincipal" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="收款状态" style="margin-left: 26px">
                <a-select v-model="queryParam.receiveMoneyStatus" :allowClear="true">
                  <a-select-option v-for="type in receive_money_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算周期" style="margin-left: 26px">
                <a-select v-model="queryParam.settlementCycle" :allowClear="true">
                  <a-select-option v-for="type in settle_cycle" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="品牌" style="margin-left: 55px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="changeBrandName"
                  :filterOption="filterOption"
                  v-model="queryParam.brand"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectBrand" :title="type.brandName" :key="type.brandId">{{
                    type.brandName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="型号" style="margin-left: 60px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="changeModelName"
                  :filterOption="filterOption"
                  v-model="queryParam.model"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectModel" :title="type.modelName" :key="type.modelId">{{
                    type.modelName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="对账单" style="margin-left: 39px">
                <a-select v-model="queryParam.statementFlag" :allowClear="true">
                  <a-select-option value="1" title=" 生成"> 生成 </a-select-option>
                  <a-select-option value="0" title="未生成"> 未生成 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="暂不结算" style="margin-left: 26px">
                <a-select v-model="queryParam.temporarilySettle" :allowClear="true">
                  <a-select-option value="0" title=" 否"> 否 </a-select-option>
                  <a-select-option value="1" title=" 是"> 是 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="购买渠道" style="margin-left: 26px">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    @change="changesourceName"
                    :filterOption="filterOption"
                    v-model="queryParam.channel"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectChannel" :title="type.channelName" :key="type.channelId"
                      >{{ type.channelName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="建单人" style="margin-left: 45px">
                  <a-input v-model.trim="queryParam.createUser" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单负责人" style="margin-left: 13px">
                  <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                    <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                      type.userName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单子状态" style="margin-left: 13px">
                  <a-select v-model="queryParam.orderSubStatus" :allowClear="true">
                    <a-select-option v-for="type in order_substate" :title="type.dictLabel" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="备注" style="margin-left: 55px">
                  <a-input v-model="queryParam.remark" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item>
                  <a-col :md="6" :sm="24">
                    <a-select v-model="queryParam.time1Type" :allowClear="true">
                      <a-select-option value="createTime" title="建单时间"> 建单时间 </a-select-option>
                      <a-select-option value="orderFinishTime" title="订单完成时间"> 订单完成时间 </a-select-option>
                      <a-select-option value="temporarilySettleTime" title="暂不结算时间">
                        暂不结算时间
                      </a-select-option>
                      <a-select-option value="receiveMoneyTime" title="收款时间"> 收款时间 </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="18" :sm="24">
                    <a-range-picker
                      v-model="time1"
                      style="width: 100%"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangetime1"
                    />
                  </a-col>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item>
                  <a-col :md="6" :sm="24">
                    <a-select v-model="queryParam.time2Type" :allowClear="true">
                      <a-select-option value="createTime" title="建单时间"> 建单时间 </a-select-option>
                      <a-select-option value="orderFinishTime" title="订单完成时间"> 订单完成时间 </a-select-option>
                      <a-select-option value="temporarilySettleTime" title="暂不结算时间">
                        暂不结算时间
                      </a-select-option>
                      <a-select-option value="receiveMoneyTime" title="收款时间"> 收款时间 </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="18" :sm="24">
                    <a-range-picker
                      v-model="time2"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      style="width: 100%"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangetime2"
                    />
                  </a-col>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="对账单编号" style="margin-left: 15px">
                  <a-input v-model.trim="queryParam.statementNo" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="query()">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="exportCustomerExpense" @click="exportEnt()"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-divider />
          <div class="table-operator">
            <a-row>
              <a-col :span="18"></a-col>
              <a-col :span="6" :style="{ textAlign: 'right' }">
                <div style="margin-bottom: 16px; margin-right: 0px">
                  <a-button
                    type="primary"
                    style="margin-right: 0px"
                    v-if="generateCustomerExpense"
                    @click="gocustGeneratestate"
                  >
                    生成对账单
                  </a-button>
                  <span>
                    <template v-if="hasSelected">
                      {{ `选中 ${selectedRowKeys.length} 条对账单` }}
                    </template>
                  </span>
                </div>
              </a-col>
            </a-row>
          </div>
          <!--    生成对账单的按钮和方法-->

          <!--    表格内容-->
          <s-table
            size="default"
            ref="table"
            rowKey="sourceId"
            :columns="columns"
            :data="loadData"
            bordered
            :scroll="{ x: 4000 }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <span slot="remark" slot-scope="text, record">
              <span v-if="record.remark">
                <span v-for="tab in record.remark.split('/$/,')">
                  <span>
                    {{ tab }}
                  </span>
                  <br />
                </span>
              </span>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a-popover title="订单备注">
                <template slot="content">
                  <span v-if="record.remark">
                    <span v-for="tab in record.remark.split('/$/,')"
                      ><span>{{ tab }}</span>
                      <br />
                    </span>
                  </span>
                </template>
                <a type="primary">
                  {{ record.orderNo }}
                </a>
              </a-popover>
            </span>
            <span slot="totalPrice" slot-scope="text, record">
              <a-popover title="企业费用明细">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-if="record.amountDetail">
                    <span v-for="tab in record.amountDetail.split('/$/')"
                      ><span>{{ tab }}</span>
                      <br />
                    </span>
                  </div>
                </template>
                <a type="primary">
                  {{ record.totalPrice }}
                </a>
              </a-popover>
            </span>
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <!--查看按钮-->
              <a v-if="seeCustomerExpense" @click="orderdetailsView(record.orderId)">查看</a>
              <a-divider type="vertical" v-if="remarkCustomerExpense" />
              <!--备注按钮-->
              <a v-if="remarkCustomerExpense" @click="remarkList(record)">备注</a>
              <a-divider type="vertical" v-if="generateCustomerExpense && record.statementFlagCode == 0" />
              <!--生成对账单按钮-->
              <a v-if="generateCustomerExpense && record.statementFlagCode == 0" @click="goEnterpriseOne(record)"
                >生成对账单</a
              >
              <a-divider
                type="vertical"
                v-if="
                  (customerExpenseSettl && record.receiveMoneyStatusCode == 0) || record.receiveMoneyStatusCode == 1
                "
              />
              <!--确认收款按钮-->
              <!--{{record.receiveMoneyStatusCode}}-->
              <a
                v-if="
                  (customerExpenseSettl && record.receiveMoneyStatusCode == 0) || record.receiveMoneyStatusCode == 1
                "
                @click="ConfirmReceipt(record, 1)"
                >确认收款</a
              >
              <a-divider
                type="vertical"
                v-if="
                  (customerExpenseRefund && record.receiveMoneyStatusCode == 2) || record.receiveMoneyStatusCode == 3
                "
              />
              <!-- 退款按钮-->
              <a
                v-if="
                  (customerExpenseRefund && record.receiveMoneyStatusCode == 2) || record.receiveMoneyStatusCode == 3
                "
                @click="ConfirmReceipt(record, 0)"
                >退款</a
              >
            </span>
          </s-table>
        </a-form>
      </div>

      <!--// 确定收款-->
      <a-modal
        :title="type == 0 ? '退款' : '确认收款'"
        style="top: 20px"
        :width="800"
        v-model="collectionible"
        @ok="collectionConfirm"
        :okText="type == 0 ? '退款' : '确认收款'"
      >
        <a-form :form="collectionform">
          <a-form-item style="display: none">
            <a-input v-decorator="['orderId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="type == 0 ? '实际收款' : '需支付'">
            <a-input v-decorator="['needpayAmount']" disabled />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="type == 0 ? '退款' : '实际支付'">
            <a-input-number
              v-decorator="[
                'amount',
                {
                  rules: [{ required: true, message: '请输入金额!' }],
                },
              ]"
              :max="this.collectionform.getFieldValue('needpayAmount')"
              @change="amountModify"
              style="width: 100%"
            />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="type == 0 ? '余额' : '未支付'">
            <a-input v-decorator="['Unpaid']" disabled />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
            <a-select v-decorator="['payMethod', { rules: [{ required: true, message: '请选择支付方式!' }] }]">
              <a-select-option v-for="type in pay_method" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" v-if="type == 0">
            <a-input v-decorator="['remark']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" v-else>
            <a-input
              v-decorator="[
                'remark',
                {
                  rules: [
                    {
                      required: this.collectionform.getFieldValue('Unpaid') > 0 ? true : false,
                      message: '请输入备注信息!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 使用弹框组件-->
      <a-modal :title="Toptitle" style="top: 20px" width="70%" v-model="generateible" footer="">
        <a-table
          :scroll="{ x: 1000 }"
          size="default"
          rowKey="sourceId"
          :columns="generatecolumns"
          :dataSource="DataList"
          bordered
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record" style="white-space: nowrap">
            <a @click="billingView(record)">查看</a>
            <a-divider type="vertical" />
            <a @click="modifyDefaultTemplate(record)">修改默认模板</a>
            <a-divider type="vertical" />
            <a @click="remarkList(record)">备注</a>
            <a-divider type="vertical" />
            <a @click="remove(record)">移除</a>
          </span>
        </a-table>
        <div style="margin-bottom: 16px">
          <a-button type="primary" @click="EnterpriseStatementConfirm()" style="margin-right: 20px; margin-top: 20px">
            生成对账单
          </a-button>
          <a-button
            type="primary"
            @click="goEnterpriseBill()"
            :loading="loading"
            style="margin-right: 20px; margin-top: 20px"
          >
            取消
          </a-button>
          <!--<a-button type="primary" @click=""  :loading="loading" >-->
          <!--修改默认模板-->
          <!--</a-button>-->
        </div>
      </a-modal>
      <!--    移除对账单确定按钮-->
      <a-modal title="移除" style="top: 20px" :width="800" v-model="removeible" @ok="confirmOk" @cancel="confirmCancel">
        <p>确定移除该条对账单吗？</p>
      </a-modal>
      <a-modal
        title="查看账单信息"
        style="top: 20px"
        :width="1600"
        v-model="informationible"
        @click="clicInformationModal"
        footer=""
      >
        <a-form :form="form">
          <a-table
            size="default"
            rowKey="sourceId"
            :columns="informationcolumns"
            :dataSource="billinglist"
            bordered
            :pagination="false"
            :scroll="{ x: 3000 }"
          >
            <span slot="remark" slot-scope="text, record">
              <span v-if="record.remark">
                <span v-for="tab in record.remark.split('/$/,')">
                  <span>
                    {{ tab }}
                  </span>
                  <br />
                </span>
              </span>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a @click="orderNodetailsView(record.orderId)">{{ record.orderNo }}</a>
            </span>
          </a-table>
        </a-form>
      </a-modal>
      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkgenerateible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item style="display: none">
            <a-input v-decorator="['enterpriseId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item style="display: none">
            <a-input v-decorator="['enterpriseId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <!--    生成对账单确定按钮-->
      <!--<a-modal-->
      <!--title="生成企业对账单"-->
      <!--v-model="Enterprisevisible"-->
      <!--@ok="EnterpriseOk"-->
      <!--:confirmLoading="confirmLoading"-->
      <!--@cancel="handleCancel"-->
      <!--cancelText="返回"-->
      <!--okText="确认且进入对账单"-->

      <!--&gt;-->
      <!--<p>对账单已生成，是否进入对账单列表？</p>-->
      <!--</a-modal>-->
      <modify-default-template-model ref="modify"></modify-default-template-model>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
      <associated-order-model ref="associatedorder" @ok="updateFeedbacklist"></associated-order-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>
import NoAuthority from '../enterprise/NoAuthority'
import { getTemplate } from '@/api/finance/customerSingle'
import modifyDefaultTemplateModel from './modules/modifyDefaultTemplateModel.vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import associatedOrderModel from '@/views/order/modules/associatedOrderModel'
import moment from 'moment'
import { STable } from '@/components'
import { getselectChannel, getselectSource, getselectCombox } from '@/api/order/NewlyaddedOrderList'
import {
  getSourceList,
  getEnterpriseList,
  getConfirmList,
  getRefundList,
  payreceiptHistory,
  refundreceiptHistory,
  getalreadyPay,
  getconfirmcustomer,
  getexportList,
} from '@/api/finance/CustomerExpense'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
  getfinddictAll,
} from '@/api/order/orderList'
import { getremarkList, saveremarkList } from '@/api/finance/enterpriseBill'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import pick from 'lodash.pick'
import ACol from 'ant-design-vue/es/grid/Col'
export default {
  name: 'CustomerExpense',
  components: {
    ACol,
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    modifyDefaultTemplateModel,
    associatedOrderModel,
    NoAuthority,
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      DataList: [],
      time_type: [],
      Toptitle: '',
      Ifstatus: 0,
      time2: '',
      time1: '',
      generatecolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '订单总计',
          dataIndex: 'orderAmount',
          align: 'center',
        },
        {
          title: '账单截止日期',
          dataIndex: 'closingDate',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
      ],
      // 查询信息来源下拉框
      selectSource: [],
      // Enterprisevisible:false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      findByDeptId: [],
      order_substate: [],
      selectModel: [],
      selectBrand: [],
      // 查询购买渠道下拉框
      selectChannel: [],
      selectCombox: [],
      marketPrincipal: [],
      selectedRowKeys: [], // Check here to configure the default column
      selectedRow: [],
      // 存选中的id
      orderIdArr: [],
      loading: false,
      generateible: false,
      removeible: false,
      collectionible: false,
      refundible: false,
      form: this.$form.createForm(this),
      collectionform: this.$form.createForm(this),
      refundform: this.$form.createForm(this),
      // 查询参数,
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '收款状态',
          dataIndex: 'receiveMoneyStatus',
          align: 'center',
        },
        {
          title: '支付方式',
          dataIndex: 'customerPayType',
          align: 'center',
        },
        {
          title: '收款时间',
          dataIndex: 'receiveMoneyTime',
          align: 'center',
        },
        {
          title: '状态栏',
          dataIndex: 'majorOrderFlag',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px',
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',
          scopedSlots: { customRender: 'totalPrice' },
          align: 'center',
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center',
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center',
        },
        {
          title: '实际收款',
          dataIndex: 'alreadyPayAmount',
          align: 'center',
        },
        {
          title: '未收款',
          dataIndex: 'needPayAmount',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center',
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center',
        },
        {
          title: '暂不结算时间',
          dataIndex: 'temporarilySettle',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',

          width: '380px',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      SourceList: [],
      List: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getSourceList(Object.assign(parameter, this.queryParam))
      },
      data: [],
      // 省
      selectAllProvince: [],
      receive_money_status: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      settle_cycle: [],
      // 字典为是否
      restaurantTypes: [],
      // 字典为安装类型
      installTypes: [],
      orderid: [],
      pay_method: [],
      // 字典为时间类型
      timetype: [],
      informationcolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: '收款状态',
          dataIndex: 'receiveMoneyStatus',
          align: 'center',
        },
        {
          title: '支付方式',
          dataIndex: 'customerPayType',
          align: 'center',
        },
        {
          title: '收款时间',
          dataIndex: 'receiveMoneyTime',
          align: 'center',
        },
        {
          title: '状态栏',
          dataIndex: 'majorOrderFlag',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px',
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',
          align: 'center',
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center',
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center',
        },
        {
          title: '实际收款',
          dataIndex: 'alreadyPayAmount',
          align: 'center',
        },
        {
          title: '未收款',
          dataIndex: 'needPayAmount',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center',
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center',
        },
        {
          title: '暂不结算时间',
          dataIndex: 'temporarilySettle',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',

          width: '380px',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      remarkrecord: '',
      recordorderId: '',
      type: '',
      remarkible: false,
      remarkgenerateible: false,
      informationible: false,
      remarkrows: [],
      billinglist: [],
      // 字典为订单状态类型
      orderstatus: [],
      billingrecord: '',
      customerExpenseSettl: checkPermission('CustomerExpenseSettl'),
      generateCustomerExpense: checkPermission('GenerateCustomerExpense'),
      remarkCustomerExpense: checkPermission('remarkCustomerExpense'),
      exportCustomerExpense: checkPermission('exportCustomerExpense'),
      customerExpenseRefund: checkPermission('customerExpenseRefund'),
      seeCustomerExpense: checkPermission('seeCustomerExpense'),
      CustomerExpenselist: checkPermission('CustomerExpense:query:list'),
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {
    let dictTypes = [
      'pay_method',
      'order_status',
      'time_type',
      'order_substate',
      'sys_yes_no',
      'install_type',
      'settle_cycle',
      'receive_money_status',
    ]
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.pay_method = res.pay_method
      this.orderstatus = res.order_status
      this.order_substate = res.order_substate
      this.restaurantTypes = res.sys_yes_no
      this.installTypes = res.install_type
      this.time_type = res.time_type
      this.settle_cycle = res.settle_cycle
      this.receive_money_status = res.receive_money_status
    })

    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
    this.selectSource = []
    // 查询信息来源下拉框
    await getselectSource().then((res) => {
      if (res.code === 0) {
        this.selectSource = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectChannel = []
    // 查询信息来源下拉框
    await getselectChannel().then((res) => {
      if (res.code === 0) {
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectModel = []
    await getSelectModel().then((res) => {
      if (res.code === 0) {
        this.selectModel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectBrand = []
    await getSelectBrand().then((res) => {
      if (res.code === 0) {
        this.selectBrand = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    // 订单负责人
    this.marketPrincipal = []
    await getmarketPrincipal().then((res) => {
      this.marketPrincipal = res
    })
    // 企业名称
    this.selectCombox = []
    await getselectCombox().then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
        // console.log(this.selectCombox)
      } else {
        this.$message.error(res.msg)
      }
    })
    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  // 计算选中的数据条数
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
  },
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    empty() {
      this.queryParam = {}
      this.time2 = ''
      this.time1 = ''
    },
    moment,
    query() {
      this.$refs.table.refresh(true)
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    // 修改默认模板
    modifyDefaultTemplate(record) {
      // console.log(record)
      getTemplate({ enterpriseId: record.enterpriseId }).then((res) => {
        if (res.code === 0) {
          console.log(res.data)
          this.$refs.modify.showmodify(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportEnt() {
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/customerBill/export?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      // parent.location.href = getVUE_APP_GATEWAR_BASE_URL1()+"/api/apartment/callManage/exportCallManage?"+'attendanceTimestr='+this.queryParam.attendanceTimestr+'&callType='+this.queryParam.callType+'&checkInStatus='+this.queryParam.checkInStatus+'&name='+this.queryParam.name
      // getexportList(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_师傅账单'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    EnterpriseOk() {
      this.generateible = false
      // this.Enterprisevisible = false;
      let obj = {
        orderNum: this.reslist.orderNum,
        statementNum: this.reslist.statementNum,
        subStatementDtos: this.DataList,
      }
      getconfirmcustomer(obj).then((res) => {
        if (res.code === 0) {
          this.loading = true
          this.$router.push({ name: 'customerStatementsList' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    orderNodetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.associatedorder.showeditOrder(orderId, '', 0)
      })
    },
    orderdetailsView(orderId) {
      // this.$refs.editorder.showeditOrder(orderId)
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(orderId, '', 0)
      })
    },
    clicInformationModal() {
      this.informationible = false
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.remarkgenerateible = false

      if (this.recordorderId) {
        this.form.validateFields((err, values) => {
          values.billRemarkType = 3
          values.orderId = this.recordorderId
          if (!err) {
            saveremarkList(values).then((res) => {
              if (res.code === 0) {
                this.$refs.table.refresh()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else {
        let Sub = this.reslist.subStatementDtos.indexOf(this.remarkrecord)
        // console.log(Sub);
        if (Sub !== -1) {
          //当没有多余tab时就不再删除
          this.reslist.subStatementDtos[Sub].remark = this.form.getFieldValue('remark')
        }
        // console.log(this.form.getFieldValue('remark'));
      }
    },
    // 移除确定时调用的方法
    confirmOk() {
      this.removeible = false
      this.DataList = this.DataList.filter((item) => !this.orderid.includes(item.enterpriseId))
      this.Toptitle = '本次选择' + this.reslist.orderNum + '个订单，共生成' + this.reslist.statementNum + '个对账单：'
    },
    EnterpriseStatementConfirm() {
      if (this.DataList) {
        this.loading = true
        if (this.DataList.length > 0) {
          // this.Enterprisevisible=true
          this.EnterpriseOk()
        } else {
          this.$message.error('无账单可生成')
        }
      } else {
        this.$message.error('无账单可生成')
      }
    },
    goEnterpriseBill() {
      this.generateible = false
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    billingView(record) {
      this.billingrecord = record
      this.informationible = true
      getSourceList({ orderIds: record.orderIds.join(',') }).then((res) => {
        if (res.code === 0) {
          this.billinglist = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkList(record) {
      this.form.resetFields()
      this.remarkrows = []
      this.remarkrecord = ''
      this.recordorderId = ''

      if (record.enterpriseId) {
        this.remarkible = true
        this.remarkrecord = record
      } else {
        this.remarkgenerateible = true
        this.recordorderId = record.orderId
        getremarkList({ billRemarkType: 3, orderId: record.orderId }).then((res) => {
          if (res.code === 0) {
            this.$refs.table.refresh()
            this.remarkrows = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 移除
    remove(record) {
      this.removeible = true
      this.orderid.push(record.enterpriseId)
    },
    collectionConfirm() {
      this.collectionform.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          if (this.type == 1) {
            payreceiptHistory(values).then((res) => {
              if (res.code === 0) {
                this.collectionible = false
                this.$refs.table.refresh()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
          if (this.type == 0) {
            refundreceiptHistory(values).then((res) => {
              if (res.code === 0) {
                this.collectionible = false
                this.$refs.table.refresh()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    // 计算未支付值
    amountModify(e) {
      let needpayAmount = this.collectionform.getFieldValue('needpayAmount')
      this.collectionform.setFieldsValue({
        Unpaid: needpayAmount - 0 - e,
      })
    },
    // 确认收款
    ConfirmReceipt(record, type) {
      this.type = type
      this.collectionform.resetFields()
      setTimeout(() => {
        this.collectionform.setFieldsValue({
          orderId: record.orderId,
        })
      }, 100)
      this.collectionible = true
      if (type == 1) {
        getConfirmList({ orderId: record.orderId }).then((res) => {
          // console.log(res)
          if (res.code === 0) {
            setTimeout(() => {
              this.collectionform.setFieldsValue({
                needpayAmount: res.data,
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (type == 0) {
        getalreadyPay({ orderId: record.orderId }).then((res) => {
          console.log(res)
          if (res.code === 0) {
            setTimeout(() => {
              this.collectionform.setFieldsValue({
                needpayAmount: res.data,
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 市
    getselect(e) {
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangetime1(date, dateString) {
      this.queryParam.time1Begin = dateString[0]
      this.queryParam.time1End = dateString[1]
    },
    onChangetime2(date, dateString) {
      this.queryParam.time2Begin = dateString[0]
      this.queryParam.time2End = dateString[1]
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 点按钮生成对账单
    gocustGeneratestate() {
      console.log(this.reslist)
      if (this.$refs.table.localDataSource.length > 0) {
        this.orderIdArr = []
        this.reslist = {}
        // 有选中的值传id
        if (this.selectedRowKeys.length > 0) {
          this.selectedRow.forEach((item) => {
            return this.orderIdArr.push(item.orderId)
          })
          // console.log(this.orderIdArr)
          getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then((res) => {
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
              // 响应的数据    // 路由跳转
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          // 没有选中的值传筛选信息
          getEnterpriseList({ isAll: 1, searchParam: this.queryParam }).then((res) => {
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
              // 响应的数据    // 路由跳转
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else {
        this.$message.error('无账单生成')
      }
    },
    // 点操作栏生成对账单
    goEnterpriseOne(record) {
      this.reslist = {}
      this.orderIdArr = []
      this.orderIdArr.push(record.orderId)
      getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then((res) => {
        console.log(res.data)
        if (res.code === 0) {
          this.DataList = res.data.subStatementDtos
          this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
          this.reslist = res.data
          this.generateible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 把复选框的索引和数据保存
    onSelectChange(selectedRowKeys, selectedRow) {
      this.selectedRow = selectedRow
      console.log(this.selectedRow)
      this.selectedRowKeys = selectedRowKeys
    },

    // 备注
    handleremark(record) {
      this.$refs.modal.remark(record.remark)
    },
  },
  watch: {},
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>